
































































































import { NavigationMixin } from '@/mixins/navigationMixin'
import { ConfirmDialogInterface, StickyPageInterface } from '@/config/interfaces'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { apiRoutes } from '@/helpers/ApiRoutes'

export default NavigationMixin.extend({
  name: 'SideNavigation',

  components: { ConfirmDialog },

  data: () => ({
    imgWidth: 24,
    imgHeight: 24,
    showPopup: false,
    logoutUri: '',
    titleStyle: {
      fontSize: '1rem',
      lineHeight: '1.5',
      fontWeight: 'normal'
    },
    confirmDialog: {
      confirmBtnTitle: 'Da',
      declineBtnTitle: 'Odustani',
      title: 'Da li ste sigurni?'
    } as ConfirmDialogInterface
  }),

  computed: {
    stickyPage (): StickyPageInterface {
      return this.$store.getters.getStickyPage
    },
    helpAndSupportPageUrl (): string {
      return apiRoutes.helpAndSupport
    }
  }
})
